import React, { RefObject } from "react";
import { RouteComponentProps } from "react-router";
import { request, handleValidationErrors } from "../helpers/utilities";
import { Spin, message } from "antd";
import Card from "../components/Card";
import queryString from "query-string";
import { AxiosResponse } from "axios";
import { FormInstance } from "antd/lib/form";
import BaseForm from "../components/Form/BaseForm";
import { FormFieldConfig, APIError } from "../helpers/shared-interfaces";
import * as Sentry from "@sentry/browser";
import { generateDisplayErrorMessage } from "../helpers/utilities";


interface State {
  name: string;
  id: string | number;
  isLoading: boolean;
}

interface RouteParams {
  id: string;
}

export const UPDATE_ROLE = `
  mutation UpdateRole($id:ID!, $name: String!) {
    updateRole(id: $id, name: $name ){
      role {
        id
        name
      }
      errors {
        property
        description
      }
    }
  }
    
`;

export default class EditRole extends React.Component<
  RouteComponentProps<RouteParams>,
  State
> {
  reference: RefObject<FormInstance>;

  constructor(props: Readonly<RouteComponentProps<RouteParams>>) {
    super(props);
    this.state = { name: "", isLoading: true, id: "" };
    this.redirectToRolePage = this.redirectToRolePage.bind(this);
    this.reference = React.createRef<FormInstance>();

    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateRole = this.updateRole.bind(this);
  }

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.reference = ref;
  };

  handleInputChange(e: React.ChangeEvent<HTMLInputElement>): void {
    this.setState({ name: e.target.value });
  }

  async updateRole(): Promise<void> {
    interface Response {
      data?: {
        updateRole?: {
          role?: {
            name: string;
          };
          errors?: APIError[];
        };
      };
      errors?: Record<string, unknown>[];
    }

    if (!this.reference.current) return;

    let data;

    try {
      data = await this.reference.current.validateFields(["name"]);
    } catch (error) {
      handleValidationErrors(error);
      return;
    }

    try {
      const response: AxiosResponse<Response> = await request({
        query: UPDATE_ROLE,
        variables: { name: data.name, id: this.state.id },
      });

      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.updateRole &&
        response.data.data.updateRole.role
      ) {
        message.success("Role update sucessfully");
        this.redirectToRolePage();
      } else {
        message.error("Failed to update role");
      }
    } catch (error) {
      message.error(`Failed to update role - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    }
  }

  redirectToRolePage(): void {
    this.props.history.push(`/roles/${this.state.id}`);
  }

  componentDidMount(): void {
    const parsed = queryString.parse(window.location.search);
    const stringifiedObject = JSON.stringify(parsed);
    const parsedObject: {
      name: string;
    } = JSON.parse(stringifiedObject);

    this.setState({
      name: parsedObject.name,
      id: this.props.match.params.id,
      isLoading: false,
    });
  }

  render(): JSX.Element | null {
    const { name, isLoading } = this.state;

    const fields: FormFieldConfig[] = [
      {
        name: "name",
        label: "Name",
        inputType: "string",
        placeholder: "Enter Role Name ...",
        rule: "string",
        initialValue: name,
        required: true,
        colConfig: {
          span: 8,
        },
      },
    ];
    return (
      <Card header="">
        <div className="create-role-container" style={{}}>
          <Spin spinning={isLoading}>
            <BaseForm
              size="large"
              reference={this.reference}
              layout="vertical"
              fields={[
                ...fields,
                {
                  id: "updateRoleButton",
                  name: "updateRoleButton",
                  inputType: "button",
                  value: "Update",
                  required: true,
                  className: "base-button",
                  elementStyle: {
                    position: "relative",
                    top: "-11px",
                  },
                  colConfig: {
                    span: 23,
                  },
                  handleClick: this.updateRole,
                },
              ]}
              fieldsToHide={[]}
            />
          </Spin>
        </div>
      </Card>
    );
  }
}
